import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AppFrame from "../../Appframe/AppFrame";
import layout from "../../../styles/layout";

import {
  Paper,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@material-ui/core";

import sort from "fast-sort";
import AppUserService from "../../../services/appusers";
import ReportingService from "../../../services/reporting";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import colors, { colorsV2 } from "../../../styles/colors";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Title from "../../../components/common/Title";

const PatientActivityLogReportView = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientList, setPatientList] = useState(null);
  const [selectedPatientName, setSelectedPatientName] = useState("");

  const classes = makeStyles({
    table: {
      minWidth: 650,
    },
    row: {
      margin: 0,
    },
    highlightedRow: {
      margin: 0,
      backgroundColor: "#CECECE",
    },
    title: {
      fontSize: 24,
      color: colorsV2.primary,
      fontWeight: 600,
    },
  });

  const printReport = () => {
    let containerEl = document.createElement("div");
    const input = document.getElementById("reportContainer");
    let inputClone = input.cloneNode(true);
    input.appendChild(inputClone);
    containerEl.appendChild(inputClone);
    let externalWindow = window.open(
      "",
      "",
      "width=1000,height=600,left=200,top=200"
    );

    externalWindow.document.body.appendChild(containerEl);
    //Trigger automatic print and close window after.
    externalWindow.onafterprint = () => {
      externalWindow.close();
    };
    setTimeout(() => {
      externalWindow.print();
    }, 3000);
  };

  useEffect(() => {
    //Run on load
    if (props.apps && props.apps.providerAppId) {
      AppUserService()
        .getAppUsers(props.user.userId, props.apps.providerAppId)
        .then((response) => {
          if (response && response.users) {
            let userArray = response.users
              .filter((u) => {
                return u.hasAccess;
              })
              .map((user) => {
                return {
                  userId: user.userId,
                  isDischarged: user.isDischarged,
                  hasAccess: user.hasAccess,
                  firstName: user.userInfo.firstName,
                  lastName: user.userInfo.lastName,
                };
              });
            sort(userArray).asc([
              (u) => u.isDischarged,
              (u) => u.lastName,
              (u) => u.firstName,
            ]);

            setPatientList(userArray);
          }
        });
    }
  }, [props.apps, props.apps.providerAppId]);

  const refreshReportData = () => {
    if (selectedPatient == null) {
      alert("You must select a patient");
    } else if (startDate == null || startDate == undefined) {
      alert("Please select a valid start date");
    } else if (endDate == null || endDate == undefined) {
      alert("Please select a valid end date");
    } else if (startDate > endDate) {
      alert("Start date must be before end date");
    } else {
      setIsLoading(true);
      ReportingService()
        .getPatientActivityLogForApp(
          props.apps.providerAppId,
          startDate,
          endDate,
          selectedPatient.userId
        )
        .then((resp) => {
          setIsLoading(false);
          setReportData(resp.reportData);
        });
    }
  };
  let eventDate = null;

  return (
    <AppFrame
      auth={props.auth}
      header="Patient Activity Log"
      optionsType="channelView"
      whiteLabelSettings={props.whiteLabelSettings}
    >
      <Title text1="" text2="" goBack={() => props.history.goBack()} />
      <div>
        <Paper
          elevation={5}
          style={{ padding: 1, margin: 30, marginBottom: 50 }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "space-evenly",
              height: 60,
              flex: 1,
            }}
          >
            <FormControl style={{ width: 300 }}>
              <InputLabel id="patient_client_selector_label">
                Select Patient/Client
              </InputLabel>
              <Select
                labelId="patient_client_selector_label"
                id="patient_client_selector"
                value={selectedPatient}
                onChange={(event) => {
                  let u = event.target.value;
                  setSelectedPatient(u);
                  setSelectedPatientName(u.firstName + " " + u.lastName);
                }}
              >
                {patientList &&
                  patientList.length > 0 &&
                  patientList.map((u) => {
                    return (
                      <MenuItem value={u}>
                        {u.firstName + " " + u.lastName}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                id="startDate-picker-inline"
                label="Start Date"
                value={startDate}
                onChange={(value) => {
                  setStartDate(value);
                }}
                KeyboardButtonProps={{
                  "aria-label": "Change Start Date",
                }}
              />
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                id="endDate-picker-inline"
                label="End Date"
                value={endDate}
                onChange={(value) => {
                  setEndDate(value);
                }}
                KeyboardButtonProps={{
                  "aria-label": "Change End Date",
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <Button
              onClick={() => refreshReportData()}
              variant="outlined"
              style={{
                margin: 15,
                backgroundColor: colors.accent,
              }}
            >
              {reportData ? "Load Report" : "Refresh Report"}
            </Button>
          </div>
        </Paper>

        {!reportData && (
          <Paper
            style={{
              margin: 30,
              padding: 20,
              borderColor: colorsV2.primary,
              borderWidth: 2,
              borderStyle: "solid",
            }}
            elevation={3}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              Please use the filters above to generate the report.
            </div>
          </Paper>
        )}
        {reportData && (
          <Paper
            style={{
              margin: 30,
              padding: 20,
              borderColor: colorsV2.primary,
              borderWidth: 2,
              borderStyle: "solid",
            }}
            elevation={3}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  printReport();
                }}
                style={{ marginBottom: 20 }}
              >
                Print Report
              </Button>
            </div>
            <div id="reportContainer">
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={3}
                        className={classes.title}
                      >
                        <h2
                          style={{
                            color: colors.primary,
                            margin: 0,
                            padding: 0,
                          }}
                        >
                          {selectedPatientName}
                        </h2>
                      </TableCell>
                    </TableRow>
                    <TableRow
                      style={{
                        backgroundColor: colors.primary,
                        color: "white",
                      }}
                    >
                      <TableCell style={{ color: "white" }}>
                        Event Date
                      </TableCell>
                      <TableCell style={{ color: "white" }} align="left">
                        Event Name
                      </TableCell>
                      <TableCell style={{ color: "white" }} align="left">
                        Instruction Name
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportData != null &&
                      reportData.map((row) => {
                        let eventDateText = "";
                        //Only display the provider name once
                        if (eventDate !== row.created) {
                          eventDate = row.created;
                          eventDateText = row.created;
                        }

                        return (
                          <React.Fragment>
                            {eventDateText !== "" && (
                              <TableRow
                                style={{
                                  backgroundColor: "#F2F2F2",
                                }}
                              >
                                <TableCell scope="row" colSpan={3} align="left">
                                  {row.created}
                                </TableCell>
                              </TableRow>
                            )}
                            <TableRow key={row.eventId} className={classes.row}>
                              <TableCell></TableCell>
                              <TableCell align="left">
                                {row.eventName}
                              </TableCell>
                              <TableCell align="left">
                                {row.instructionName}
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    {reportData == null && isLoading && (
                      <TableCell align="right" colSpan={10}>
                        <h4>Loading....</h4>
                      </TableCell>
                    )}
                    {reportData && reportData.length === 0 && (
                      <TableCell align="center" colSpan={10}>
                        No patient activity found meeting the filter criteria.
                      </TableCell>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Paper>
        )}
      </div>
    </AppFrame>
  );
};

function mapStateToProps({ user, apps, appusers, whiteLabelSettings }, props) {
  return { user, appusers, apps, whiteLabelSettings, ...props };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, null)(PatientActivityLogReportView);



// WEBPACK FOOTER //
// ./src/layout/reporting/ChannelLevel/PatientActivityLogReportView.js